import { api } from "./client";

export interface Activity {
  id: string;
  account_id: string;
  type: string;
  date: string;
  quantity: number;
  unit_price: number;
  fee: number;
  currency: string;
  symbol: string | null;
  isin: string | null;
  created_at: string;
  symbol_profile?: {
    id: string;
    symbol: string;
    display_symbol?: string | null;
    name: string | null;
    currency: string | null;
    data_source: string;
  };
  comment?: string | null;
}

export interface ActivityCreate {
  account_id?: string | null;
  symbol: string;
  data_source?: string;
  date: string;
  type: string;
  quantity: number;
  unit_price: number;
  fee?: number;
  currency?: string | null;
  comment?: string | null;
  is_draft?: boolean;
}

export interface ActivityUpdate {
  account_id?: string | null;
  date?: string | null;
  type?: string | null;
  quantity?: number | null;
  unit_price?: number | null;
  fee?: number | null;
  currency?: string | null;
  comment?: string | null;
  is_draft?: boolean | null;
}

export const activitiesApi = {
  listActivities: async (params?: { account_id?: string }): Promise<Activity[]> => {
    const { data } = await api.get("/api/activities", { params });
    return data;
  },
  getActivity: async (id: string): Promise<Activity> => {
    const { data } = await api.get(`/api/activities/${id}`);
    return data;
  },
  createActivity: async (data: ActivityCreate): Promise<Activity> => {
    console.log("PAYLOAD BEING SENT TO BACKEND:", JSON.stringify(data, null, 2));
    const response = await api.post("/api/activities", data);
    return response.data;
  },
  updateActivity: async (id: string, data: ActivityUpdate): Promise<Activity> => {
    const response = await api.put(`/api/activities/${id}`, data);
    return response.data;
  },
  deleteActivity: async (id: string): Promise<void> => {
    await api.delete(`/api/activities/${id}`);
  },
  importPreview: async (file: File): Promise<ImportPreviewResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await api.post("/api/activities/import/preview", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  importActivities: async (
    file: File,
    mapping: Record<string, string>,
    accountId: string,
    defaultCurrency?: string
  ): Promise<ImportResultResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("mapping", JSON.stringify(mapping));
    formData.append("account_id", accountId);
    if (defaultCurrency) {
      formData.append("default_currency", defaultCurrency);
    }
    const { data } = await api.post("/api/activities/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
};

export interface ImportPreviewRow {
  raw: string[];
  parsed: Record<string, any>;
}

export interface ImportPreviewResponse {
  headers: string[];
  detected_mapping: Record<string, string>;
  preview_rows: ImportPreviewRow[];
  required_fields: string[];
  optional_fields: string[];
  available_order_types: string[];
}

export interface ImportErrorDetail {
  row: number;
  column: string;
  message: string;
}

export interface ImportResultResponse {
  imported_count: number;
  skipped_duplicates: number;
  created_assets: string[];
  unresolved_symbols: string[];
  errors: ImportErrorDetail[];
}
